import getLegacySuggestions from './getLegacySuggestions';
import getSubstrateSuggestions from './getSubstrateSuggestions';
import getSuggestionQueryString from '../../utils/getSuggestionQueryString';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import { SearchScenarioId } from 'owa-search-next';
import { SuggestionSet } from 'owa-search-service';

export default async function getServerSuggestions(
    scenarioId: SearchScenarioId,
    queryStringForSuggestions: string
): Promise<SuggestionSet> {
    // Return legacy suggestions if QF is not enabled.
    if (!is3SFeatureEnabled('sea-qf')) {
        return getLegacySuggestions(scenarioId, queryStringForSuggestions);
    }

    const suggestionSet = await getSubstrateSuggestions(scenarioId, queryStringForSuggestions);

    /**
     * Do not proceed if after the 3S suggestions calls returns, user has moved
     * on to a different query string.
     */
    const currentSuggestionQueryString = await getSuggestionQueryString(scenarioId);
    if (queryStringForSuggestions !== currentSuggestionQueryString) {
        return suggestionSet;
    }

    return {
        Suggestions: suggestionSet.Suggestions,
        TraceId: suggestionSet.TraceId,
        IsComplete: true,
    };
}
